<template>
  <!-- 名片信息-组件 -->
  <div style="position: absolute; top: 0; right: 0; left: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.2);" v-if="visible" @click.stop.self>
    <div v-if="visible" style="position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; margin: auto; width: 400px; border-radius: 2px; background-color: #ededed; box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);"
          :style="{height:CurrentHeight}">
          <div style="height:100%;">
              <p style="border-bottom:1px solid #bbb;text-align:center;height:45px;line-height:45px;">提示</p>
              <div>
                <p style="height: 25px;line-height: 25px;padding-left: 50px; font-size: 13px;font-weight: 600;margin-top: 10px;">您还未设置昵称，请设置昵称方便与网点沟通问题</p>
                <p style="height: 25px;line-height: 25px;padding-left: 50px;font-size: 12px;color: #999;;">昵称实例：真实姓名、xx店铺客服、xx商家仓储管理员</p>
                <p style="height: 40px;line-height: 40px;padding-left: 50px;"><span>昵称</span><input v-model="nick" @keyup="forbidSpace"  maxlength="16" type="text" name="fname" style="height: 30px;line-height: 30px;margin-left: 15px; width:245px; border-radius: 3px;border: none;" ></p>
                <p v-if="nickFlag" style="height: 20px;line-height: 20px;padding-left: 50px;font-size: 12px;color: #red;;"><span style="display: inline-block;width: 18px;height: 18px;border-radius: 50%;background: red;vertical-align: middle;
                text-align: center;font-size: 12px;color: #fff;transform: scale(0.8);">!</span><span style="margin-left: 10px;display: inline-block;vertical-align: middle;color: red;" >{{tipNameMsg}}</span></p>
                <p v-if="errorMsg" style="height: 20px;line-height: 20px;padding-left: 50px;font-size: 12px;color: #red;;"><span style="display: inline-block;width: 18px;height: 18px;border-radius: 50%;background: red;vertical-align: middle;
                text-align: center;font-size: 12px;color: #fff;transform: scale(0.8);">!</span><span style="margin-left: 10px;display: inline-block;vertical-align: middle;color: red;" >{{errorMsg}}</span></p>
              </div>
              <div style="text-align:center;margin-top: 10px;">
                <button type="button" class="button" style="width: 74px;height:36px; border-radius: 4px;background:#fff;color:#494C4F;border:1px solid #bbb;margin-right:26px;" @click="closeAll">取消</button>
                <button type="button" class="button" style="width:  74px;height:36px; border-radius: 4px;background:#653EB3;color:#fff;border:1px solid #653EB3;" @click="upDataMyInfo">确定</button>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props:{
    im: {
      type: Object,
      default: function () {
        return {}
      }
    },
    errorMsg: {
      type:String,
      default: ''
    }
  },
  data: function () {
    return {
      informationData:{},
      visible: false,
      CurrentHeight:'230px',
      custom:{},
      nick:'',
      nickFlag: false,
      tipNameMsg:'请您输入昵称'
    }
  },
  methods: {
    // 禁止输入空格
    forbidSpace: function () {
      var isNum = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
      var isChinese = /^[\u4e00-\u9fa5]$/;
      this.nick = this.nick.replace(/\s+/g,'');
      this.nick = this.nick.replace(/\`/g,'');
      this.nick = this.nick.replace(/\·/g,'');
      this.nick = this.nick.replace(/\~/g,'');
      this.nick = this.nick.replace(/\@/g,'');
      this.nick = this.nick.replace(/\#/g,'');
      this.nick = this.nick.replace(/\￥/g,'');
      this.nick = this.nick.replace(/\$/g,'');
      this.nick = this.nick.replace(/\%/g,'');
      this.nick = this.nick.replace(/\……/g,'');
      this.nick = this.nick.replace(/\…/g,'');
      this.nick = this.nick.replace(/\^/g,'');
      this.nick = this.nick.replace(/\!/g,'');
      this.nick = this.nick.replace(/\！/g,'');
      this.nick = this.nick.replace(/\&/g,'');
      this.nick = this.nick.replace(/\*/g,'');
      this.nick = this.nick.replace(/\(/g,'');
      this.nick = this.nick.replace(/\（/g,'');
      this.nick = this.nick.replace(/\）/g,'');
      this.nick = this.nick.replace(/\)/g,'');
      this.nick = this.nick.replace(/\-/g,'');
      this.nick = this.nick.replace(/\_/g,'');
      this.nick = this.nick.replace(/\——/g,'');
      this.nick = this.nick.replace(/\=/g,'');
      this.nick = this.nick.replace(/\+/g,'');
      this.nick = this.nick.replace(/\、/g,'');
      this.nick = this.nick.replace(/\\/g,'');
      this.nick = this.nick.replace(/\{/g,'');
      this.nick = this.nick.replace(/\【/g,'');
      this.nick = this.nick.replace(/\[/g,'');
      this.nick = this.nick.replace(/\]/g,'');
      this.nick = this.nick.replace(/\}/g,'');
      this.nick = this.nick.replace(/\】/g,'');
      this.nick = this.nick.replace(/\|/g,'');
      this.nick = this.nick.replace(/\;/g,'');
      this.nick = this.nick.replace(/\:/g,'');
      this.nick = this.nick.replace(/\；/g,'');
      this.nick = this.nick.replace(/\：/g,'');
      this.nick = this.nick.replace(/\’/g,'');
      this.nick = this.nick.replace(/\“/g,'');
      this.nick = this.nick.replace(/\'/g,'');
      this.nick = this.nick.replace(/\"/g,'');
      this.nick = this.nick.replace(/\《/g,'');
      this.nick = this.nick.replace(/\》/g,'');
      this.nick = this.nick.replace(/\./g,'');
      this.nick = this.nick.replace(/\>/g,'');
      this.nick = this.nick.replace(/\。/g,'');
      this.nick = this.nick.replace(/\，/g,'');
      this.nick = this.nick.replace(/\,/g,'');
      this.nick = this.nick.replace(/\</g,'');
      this.nick = this.nick.replace(/\?/g,'');
      this.nick = this.nick.replace(/\？/g,'');
      this.nick = this.nick.replace(/\//g,'');
      this.nick = this.nick.replace(/\*/g,'');
      this.nick = this.nick.replace(/\-/g,'');
      this.nick = this.nick.replace(/\+/g,'');
      this.nick = this.nick.replace(/\./g,'');
      // 判断长度 中英数字混合最长16 中文为2
      if(this.nick){
        var nickArr = this.nick.split('');
        var nickLength = 0;
        for(var i = 0; i < nickArr.length; i++){
          // 中文字符的时候
          if(isChinese.test(nickArr[i])){
            nickLength += 2;
          }else{
            nickLength += 1
            // 英文以及数字
          }
          if(nickLength > 16){
            this.nick = this.nick.substr(0,i);
          }
        }
      }

    },
    // 更新个人资料
    upDataMyInfo: function () {
      // 字母数字汉字长度16 汉字占俩位 屏蔽空格 纯数字
      var isNum = /^[0-9]*$/;
      if(this.nick){
        if(!isNum.test(this.nick)){
          this.$emit("upDataMyInfo",this.nick);
        }else{
          this.tipNameMsg = '不可以用纯数字设置昵称'
          this.nickFlag = true;
        }  
      }else{
        this.tipNameMsg = '请您输入昵称'
        this.nickFlag = true;
      }
    },
    // 点击取消关闭IM框
    closeAll: function () {
      this.$emit("closeAllIm",false);
    },
    open: function () {
      // 动态弹框高度
      if (this.visible) return;
      this.visible = true;
    },
    cancel: function () {
      
      this.close();
    },
    done: function () {
      this.close();
    },
    close: function () {
      this.visible = false;
    }
  }
}
</script>
